import i18next from 'i18next';
import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {showDeleteDialogObservable} from 'web-app/react/dialog';
import * as MealPlanSelectors from 'web-app/react/entities/meals/meal-plan/selectors';
import * as GlobalEventActions from 'web-app/react/global-event/actions';

import * as Api from './api';
import ActionTypes from './action-types';
import Actions from './actions';

const fetchMealRegistration = action$ =>
    action$.ofType(ActionTypes.MEAL_REGISTRATION_FETCH).mergeMap(({payload}) =>
        Api.fetchMealRegistration(payload.mealRegistrationId)
            .map(mealRegistration =>
                Actions.fetchMealRegistrationSuccess(
                    payload.mealRegistrationId,
                    mealRegistration,
                    payload.institutionId,
                ),
            )
            .catch(e => Observable.of(Actions.fetchMealRegistrationFailed(payload.mealRegistrationId, e))),
    );

const createMealRegistrations = (action$, state$) =>
    action$.ofType(ActionTypes.MEAL_REGISTRATIONS_CREATE).mergeMap(({payload}) => {
        let mealType = payload.mealType;

        if (!mealType) {
            const mealTypes = MealPlanSelectors.getMealTypesForInstitution(state$.value, {
                institutionId: payload.institutionId,
            });
            mealType = mealTypes.size === 1 && mealTypes.get(0).id;
        }

        return Api.createMealRegistrations(
            payload.institutionId,
            payload.childIds.toArray(),
            mealType,
            payload.mealItems,
            payload.createdAt,
        )
            .flatMap(persistedMealRegistrations => [
                Actions.createMealRegistrationsSuccess(persistedMealRegistrations),
                GlobalEventActions.updateSuccess.action(
                    i18next.t('react.entities.meals.foodConsumption.translations.json.mealLogged'),
                ),
            ])
            .catch(e => Observable.of(Actions.createMealRegistrationsFailed(e)));
    });

const updateMealRegistration = action$ =>
    action$.ofType(ActionTypes.MEAL_REGISTRATION_UPDATE).mergeMap(({payload}) =>
        Api.updateMealRegistration(payload.mealRegistration.id, payload.mealType, payload.mealItems, payload.createdAt)
            .map(updatedMealRegistration =>
                Actions.updateMealRegistrationSuccess(
                    payload.mealRegistration.id,
                    payload.mealRegistration,
                    updatedMealRegistration,
                ),
            )
            .catch(e => Observable.of(Actions.updateMealRegistrationFailed(e))),
    );

export const deleteMealRegistrationObservable = mealRegistrationId =>
    Api.deleteMealRegistration(mealRegistrationId).map(() => Actions.deleteMealRegistrationSuccess(mealRegistrationId));

const deleteMealRegistration = action$ =>
    action$.ofType(ActionTypes.MEAL_REGISTRATION_DELETE).mergeMap(({payload}) =>
        showDeleteDialogObservable({
            title: i18next.t('meals.mealRegistration.confirmDeleteTitle'),
            description: i18next.t('meals.mealRegistration.confirmDeleteDescription'),
        }).mergeMap(selection => {
            if (selection === 'OK') {
                return deleteMealRegistrationObservable(payload.mealRegistrationId).catch(e =>
                    Observable.of(Actions.deleteMealRegistrationFailed(payload.mealRegistrationId, e)),
                );
            }

            return Observable.of(Actions.deleteMealRegistrationAborted(payload.mealRegistrationId));
        }),
    );

export default combineEpics(
    fetchMealRegistration,
    createMealRegistrations,
    updateMealRegistration,
    deleteMealRegistration,
);
